import { createReducer, on } from '@ngrx/store';
import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';
import {
  ClearSchemaOptions,
  CloseEditSchema,
  CompanyTitleChanged,
  EditSchema,
  GetCompaniesSuccess,
  GetCountriesSuccess,
  GetLevelsSuccess,
  GetNexusSuccess,
  GetRedemptionTypesSuccess,
  GetTaxOfficesSuccess,
  OpenEditSchema,
  SchemaCodeChanged,
  VATNumberChanged,
} from '../actions/search.actions';
import { SearchState } from '../models/schemas.model';

const initialState: SearchState = {
  nexus: [],
  taxOffices: '',
  companies: [],
  levels: [],
  redemptionTypes: [],
  countries: [],
  panelExpanded: true,
  sideNav: false,
  schemaCode: '',
  companyTitle: '',
  vatNumber: '',
};

export const SchemasSearchReducer = createReducer(
  initialState,
  on(GetLevelsSuccess, (state, { res }) => ({
    ...state,
    levels: res,
  })),
  on(GetTaxOfficesSuccess, (state, { res }) => ({
    ...state,
    taxOffices: res,
  })),
  on(GetRedemptionTypesSuccess, (state, { res }) => ({
    ...state,
    redemptionTypes: res,
  })),
  on(GetCompaniesSuccess, (state, { res }) => ({
    ...state,
    companies: res,
  })),
  on(GetNexusSuccess, (state, { res }) => ({
    ...state,
    nexus: res,
  })),
  on(GetCountriesSuccess, (state, { res }) => ({
    ...state,
    countries: res,
  })),
  on(SchemaCodeChanged, (state, { schemaCode }) => ({
    ...state,
    schemaCode,
  })),
  on(CompanyTitleChanged, (state, { companyTitle }) => ({
    ...state,
    companyTitle,
  })),
  on(VATNumberChanged, (state, { vatNumber }) => ({
    ...state,
    vatNumber,
  })),
  on(EditSchema, (state) => ({
    ...state,
    sideNav: true,
  })),
  on(OpenEditSchema, (state) => ({
    ...state,
    sideNav: true,
  })),
  on(CloseEditSchema, (state) => ({
    ...state,
    sideNav: false,
  })),
  on(ClearSchemaOptions, (state) => ({
    ...state,
    schemaCode: '',
    companyTitle: '',
    vatNumber: '',
  })),
  on(ActiveComponentChanged, () => initialState),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
